import React from "react";

// // // //

/**
 * ReferrerPolicy
 * Add <meta name="referrer" /> to the <head> of the HTML document.
 * This sends the full URL as the referrer when navigating within the same origin,
 * and the origin only for cross-origin requests, maintaining a good balance between referral data and security.
 */
export function ReferrerPolicy() {
    return <meta name="referrer" content="strict-origin-when-cross-origin" />;
}
